$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
PopOver = require 'app/scripts/views/lib/pop-over'
MemberMiniProfileView = require 'app/scripts/views/member-menu-profile/member-mini-profile-view'

module.exports = class AboutThisBoardAdminListView extends View
  viewTitleKey: 'multi admin list'

  initialize: ->
    @listenTo @model

  render: ->
    data = @model.toJSON()

    @$el.html(
      templates.fill(
        'popover_about_this_board_admin_list',
        data
      )
    )

    @renderAdminList()

    @

  renderAdminList: ->
    $target = @$('.js-show-all-admins')
    visibleAdmins = @model.orderedVisibleAdmins()

    subviews = for admin in visibleAdmins
      @subview(MemberMiniProfileView, admin, { board: @model })
    @ensureSubviews(subviews, $target)
